// import { HasPermission } from '../../Helper/Permisstions/Permisstions';

const CashMenu = [
  {
    System: 'CASH',
    isActive: false,
    menu: [
      { is_header: true, title: 'النظام المالي', isActive: true },

      {
        path: '/CASH/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'الإعدادات', isActive: true },

      {
        path: '/CASH/Settings/BankAccounts',
        title: 'الحسابات البنكية',
        icon: 'fas fa-university', // أو fa-building-columns
        isActive: true
      },
      {
        path: '/CASH/Settings/CashBoxes',
        title: 'صناديق النقديــة',
        icon: 'fas fa-cash-register',
        isActive: true
      },
      { is_header: true, title: 'العمليـات', isActive: true },
      {
        path: '/CASH/CashTransfer',
        icon: 'fas fa-exchange-alt',
        title: 'التحويل النقدي',
        isActive: true
      },
      {
        path: '/CASH/BankSettlement',
        icon: 'fas fa-scale-balanced',
        title: 'التسويات البنكية',
        isActive: true
      },
      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/CASH/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/CASH/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
      }
    ]
  }
];

export default CashMenu;
